<template>
  <v-dialog v-model="visible" max-width="445" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn class="v-dialog--custom__close mr-2" color="gray-6" flat fab @click.native="close(null)">
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />

        <a href="#" class="text--normal accent--text mr-4" color="accent" flat round @click.prevent="close(null)">
          {{ $t(`${namespace}.cancel`) }}
        </a>

        <v-btn color="accent" depressed round @click.prevent="handleSubmit">
          {{ $t(`${namespace}.submit`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import companyService from '@/services/company'

export default {
  name: 'AddTokenDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      namespace: 'Components.AllowApiToken.addDialog'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),
    close (reload = null) {
      this.$emit('close', reload)
    },
    async handleSubmit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) return
      try {
        await companyService.addToken({ companyId: this.companyId })
        this.showAlert({ type: 'success', message: this.$t(`Components.AllowApiToken.success`) })
      } catch (e) {
        this.showAlert({ type: 'error', message: e.errmsg || this.$t(`Components.AllowApiToken.error`) })
      } finally {
        this.close()
        this.$emit('getTokenListData')
      }
    }
  }
}
</script>
